<template>
  <div>
    <div v-if="isLoading === true">
      <IconBell class="w-6 h-6 cursor-pointer">
      </IconBell>
    </div>
    <div v-else>
      <div class="flex items-end">
        <div class="mb-1.5 mr-3">
          <ClientNews :has-news="filterReleasesList.length > 0"></ClientNews>
        </div>
        <div @click="navbarStore.toggleNotificationsList()">
          <IconBell class="w-6 h-6 cursor-pointer">
          </IconBell>
        </div>
        <div v-if="navbarStore.activeNotifications > 0 "
             class="bg-primary rounded-full w-7 h-4 text-center text-xs text-white">
          {{ navbarStore.activeNotifications }}
        </div>
        <div v-if="maintenancesWithoutInteraction.length > 0"
             class="bg-red-600 rounded-full w-7 h-4 flex justify-center ml-1 items-center text-center text-xs text-white">
          {{ maintenancesWithoutInteraction.length }}
        </div>
        <div v-if="releasesWithoutInteraction.length > 0"
             class="bg-orange-500 rounded-full w-7 h-4 flex justify-center ml-1 items-center text-center text-xs text-white">
          {{ releasesWithoutInteraction.length }}
        </div>
        <div v-if="navbarStore.notificationsListOpen == true">
          <div class="bg-black bg-opacity-20 w-full h-full fixed left-0 right-0 top-0 bottom-0 z-[999]"></div>
          <div
              class="fixed right-6 rounded-lg bg-white w-[500px] z-[9999999] top-[64px] h-custom-notif shadow-soft2xl overflow-auto">
            <div class="">
              <div class="flex justify-between sticky top-0 bg-white p-4 shadow-softxs">
                <div class="flex justify-end gap-1 items-center">
                  <div class="flex items-center gap-1 px-3 py-1"
                       :class=" activeTab == 0 ? 'bg-primary rounded-full bg-opacity-10' :''">
                    <p @click="activeTab = 0" class="text-black text-sm font-semibold cursor-pointer">Notifications</p>
                    <div
                        class="bg-primary rounded-full w-7 h-5 flex justify-center items-center text-center text-xs text-white">
                      {{ navbarStore.activeNotifications }}
                    </div>
                  </div>
                  <div class="flex items-center gap-1 py-1 px-3"
                       :class=" activeTab == 1 ? 'bg-primary rounded-full bg-opacity-10 ' :''">
                    <p @click="activeTab = 1" class="text-black text-md font-semibold cursor-pointer">Maintenances</p>
                    <div
                        class="bg-red-600 rounded-full w-7 h-5 flex justify-center items-center text-center text-xs text-white">
                      {{ maintenancesWithoutInteraction.length }}
                    </div>
                  </div>
                  <div class="flex items-center gap-1 py-1 px-3"
                       :class=" activeTab == 2 ? 'bg-primary rounded-full bg-opacity-10 ' :''">
                    <p @click="activeTab = 2" class="text-black text-sm font-semibold cursor-pointer">Releases</p>
                    <div
                        class="bg-orange-500 rounded-full w-7 h-5 flex justify-center items-center text-center text-xs text-white">
                      {{ releasesWithoutInteraction.length }}
                    </div>
                  </div>
                </div>
                <IconClose @click="navbarStore.closeNotificationsList()"
                           class="fill-primary cursor-pointer"></IconClose>
              </div>
              <template v-if="activeTab === 0">
                <div v-if="navbarStore.filteredSiteNotifications.length === 0" class="ml-4 mt-4 font-semibold">
                  No notifications available
                </div>
                <div v-else class="">
                  <template v-for="site_notification in navbarStore.filteredSiteNotifications">
                    <div v-if="userInteraction(site_notification.notificationInteractions)">
                      <div class="p-6 border-b border-slate-400 bg-[#Fff] w-full flex flex-col space-y-4 cursor-pointer"
                          @click="notificationSeen(site_notification.id,'site_notification'); toggleExpanded(site_notification.id, 'client_message')">
                        <div class="flex justify-end">
                              <span class="text-blue-700 font-bold">
                              {{ DateFilterHelper.FormatAsDateWithMonthString(site_notification.client_from) }}
                              </span>
                        </div>
                        <div class="flex justify-between">
                          <strong>{{ site_notification.client_name }}</strong>

                        </div>
                        <div
                            class="font-medium cursor-pointer text-sm ck-content"
                            v-html="truncateText(site_notification.id, 'client_message', site_notification.client_message, 40)">
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div
                          class="p-6 border-b border-slate-400 bg-[#F3F8FF] w-full flex flex-col space-y-4 cursor-pointer"
                          @click="notificationSeen(site_notification.id,'site_notification'); toggleExpanded(site_notification.id, 'client_message')">
                        <div class="flex justify-end">
                              <span class="text-blue-700 font-bold justify-end">
                              {{ DateFilterHelper.FormatAsDateWithMonthString(site_notification.client_from) }}
                              </span>
                        </div>
                        <div class="flex justify-start items-center gap-3">
                          <div class="w-2 h-2 bg-primary rounded-full">
                          </div>
                          <div>
                            <strong>{{ site_notification.client_name }}</strong>

                          </div>
                        </div>
                        <div
                            class="font-medium cursor-pointer text-sm ck-content ml-5"
                            v-html="truncateText(site_notification.id, 'client_message', site_notification.client_message, 40)"
                        >
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else-if="activeTab === 1">
                <div v-if="maintenanceList.length === 0" class="ml-4 mt-4 font-semibold">
                  No maintenances available
                </div>
                <template v-for="maintenance in maintenanceList">
                  <div>
                    <div class="p-6 border-b border-slate-400 w-full flex flex-col space-y-4 cursor-pointer"
                         :class="userInteraction(maintenance.notificationInteractions) ? 'bg-[#Fff]' : 'bg-[#F3F8FF]'"
                         @click="notificationSeen(maintenance.id, 'maintenance')">
                      <div class="flex justify-end">
                              <span class="text-red-600 font-bold">
                              {{ DateFilterHelper.FormatAsDateWithMonthString(maintenance.from) }}
                              </span>
                      </div>
                      <div class="flex justify-start items-center gap-3">
                        <div class="w-2 h-2 bg-primary rounded-full">
                        </div>

                        <div class="font-semibold">
                          {{ maintenance.name }}
                        </div>
                      </div>
                      <div
                          class="font-medium cursor-pointer text-sm ck-content ml-5"
                          v-html="maintenanceRenderedText(maintenance.id)"
                      >
                      </div>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <div v-if="releasesList.length === 0" class="ml-4 mt-4 font-semibold">
                  No release available
                </div>
                <template v-for="release in releasesList">
                  <template v-if="release.client_release_enabled">
                    <div v-if="userInteraction(release.notificationInteractions)"
                         @click="notificationSeen(release.id, 'release')">
                      <div class="p-6 border-b border-slate-400 bg-[#Fff] w-full flex flex-col cursor-pointer">
                        <div class="flex justify-between items-center">
                          <p>
                            <span v-if="authStore.user.isDeveloper" class="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 uppercase tracking-wide">
                              OneClick
                            </span>
                          </p>
                          <p v-if="release.client_release_date !== null" class="text-orange-500 font-bold block float-right">
                            {{ DateFilterHelper.FormatAsDateWithMonthString(release.client_release_date) }}
                          </p>
                        </div>

                        <div class="flex justify-between mb-3">
                          <strong>{{ release.client_title }}</strong>
                        </div>
                        <div v-html="release.client_short_description"></div>
                      </div>
                    </div>
                    <div v-else
                         class="p-6 border-b border-slate-400 bg-[#F3F8FF] w-full flex flex-col  cursor-pointer"
                         @click="notificationSeen(release.id, 'release')">
                      <div class="flex justify-between items-center">
                        <p>
                            <span v-if="authStore.user.isDeveloper" class="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 uppercase tracking-wide">
                              OneClick
                            </span>
                        </p>
                        <p v-if="release.client_release_date !== null" class="text-orange-500 font-bold block float-right">
                          {{ DateFilterHelper.FormatAsDateWithMonthString(release.client_release_date) }}
                        </p>
                      </div>

                      <div class="flex justify-start items-center gap-3 mb-3">
                        <div class="w-2 h-2 bg-primary rounded-full"></div>
                        <div class="flex justify-between">
                          <strong>{{ release.client_title }}</strong>
                        </div>
                      </div>
                      <div v-html="release.client_short_description"></div>
                    </div>
                  </template>
                  <template v-else-if="release.self_service_release_enabled">
                    <div v-if="userInteraction(release.notificationInteractions)"
                         @click="notificationSeen(release.id, 'api_release')">
                      <div class="p-6 border-b border-slate-400 bg-[#Fff] w-full flex flex-col cursor-pointer">
                        <div class="flex justify-between items-center">
                        <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 uppercase tracking-wide">
                          API Self-Service
                        </span>
                          <p class="text-orange-500 font-bold">
                            {{ DateFilterHelper.FormatAsDateWithMonthString(release.self_service_release_date) }}
                          </p>
                        </div>

                        <div class="flex justify-between mt-2 mb-3">
                          <strong>{{ ApiReleaseHelper.serviceValues.find(el => el.value == release.service)?.label }} - {{ release.self_service_title }}</strong>
                        </div>
                        <div v-html="release.self_service_short_description"></div>
                      </div>
                    </div>
                    <div v-else
                         class="p-6 border-b border-slate-400 bg-[#F3F8FF] w-full flex flex-col  cursor-pointer"
                         @click="notificationSeen(release.id, 'api_release')">
                      <div class="flex justify-between items-center">
                        <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 uppercase tracking-wide">
                          API Self-Service
                        </span>
                        <p class="text-orange-500 font-bold">
                          {{ DateFilterHelper.FormatAsDateWithMonthString(release.self_service_release_date) }}
                        </p>
                      </div>

                      <div class="flex justify-start items-center gap-3 mt-2 mb-3">
                        <div class="w-2 h-2 bg-primary rounded-full"></div>
                        <div class="flex justify-between">
                          <strong>{{ ApiReleaseHelper.serviceValues.find(el => el.value == release.service)?.label }} - {{ release.self_service_title }}</strong>
                        </div>
                      </div>
                      <div v-html="release.self_service_short_description"></div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <SiteNotificationPopup v-if="navbarStore.notificationPopupOpen"></SiteNotificationPopup>
    </div>
  </div>
</template>

<script setup lang="ts">

import IconClose from "@/components/svg_icons/IconClose.vue";
import IconBell from "@/components/svg_icons/IconBell.vue";
import {SiteNotification,type SiteNotificationData} from "@/types/site_admin/siteNotifications";
import {computed, ref} from "vue";
import {useApiStore} from "@/stores/api";
import {useNavbarStore} from "@/stores/navbar";
import SiteNotificationPopup from "@/components/widgets/notifications/SiteNotificationPopup.vue";
import type {QueryFilter} from "@/types/object_classes/QueryFilter";
import {Release, type ReleaseData} from "@/types/site_admin/releases";
import {Maintenance, type MaintenanceData} from "@/types/site_admin/maintenances";
import {useRouter} from "vue-router";
import {DateFilterHelper} from "@/helpers/DateFilterHelper";
import Mustache from 'mustache';
import {useAuthStore} from "@/stores/auth";
import {NotificationInteraction} from "@/types/site_admin/notificationInteraction";
import type {JsonApiPagination} from "@/types/object_classes/JsonApiPagination";
import ClientNews from "@/components/widgets/navbar/ClientNews.vue";
import ApiNews from "@/components/widgets/navbar/ApiNews.vue";
import {ApiReleaseHelper} from "@/helpers/ApiReleaseHelper";

const router = useRouter();
const api = useApiStore();
const authStore = useAuthStore();
const navbarStore = useNavbarStore();
const isLoading = ref(false);
const expandedItems = ref({});
const releasesList = ref<Release[]>([]);
const activeTab = ref(0);
const maintenances = ref<Maintenance[]>([]);

const maintenanceRenderedText = computed(() => (maintenance_id) => {
  const maintenanceData = maintenanceList.value.find(el => el.id === maintenance_id);

  const data = JSON.parse(JSON.stringify(maintenanceData.extra_data));
  data.from = DateFilterHelper.FormatAsDateWithDotsAndHours(data.from);
  data.until = DateFilterHelper.FormatAsDateWithDotsAndHours(data.until);

  return Mustache.render(maintenanceData.text, data);
});

const maintenanceList = computed(() => {
  return maintenances.value.filter(el => el.client_enabled && el.until?.getTime() >= Date.now());
});
const filterReleasesList = computed(() => {
  return releasesList.value.filter(el => el.client_release_enabled === true && el.client_from?.getTime() <= Date.now() && el.client_until?.getTime() > Date.now());
});
const filterApiReleasesList = computed(() => {
  return releasesList.value.filter(el => el.self_service_release_enabled === true && el.self_service_from?.getTime() <= Date.now() && el.self_service_until?.getTime() > Date.now());
});

const maintenancesWithoutInteraction = computed(() => {
  let maintenancesWithout = [];
  maintenanceList.value.forEach(maintenance => {
    if (!maintenance.notificationInteractions.find(el => el.user_id == authStore.user.id)) {
      maintenancesWithout.push(maintenance);
    }
  })
  return maintenancesWithout;
});

const releasesWithoutInteraction = computed(() => {
  let releasesWithout = [];

  releasesList.value.forEach(release => {
    if (!release.notificationInteractions.find(el => el.user_id == authStore.user.id)) {
      releasesWithout.push(release);
    }
  })

  return releasesWithout;
});

const loadFromServer = () => {
  isLoading.value = true;

  const notificationFilter: QueryFilter = {
    delimiter: null,
    field: "client_enabled",
    values: [1]
  }

  const notificationPagination : JsonApiPagination = {
    page_number: 1,
    page_size: 5
  }
  const releasePagination: JsonApiPagination = {
    page_number: 1,
    page_size: 5
  }

  const notificationSortBy = ['-client_from', '-id'];
  const maintenanceSortBy = ['-from', '-id'];
  const releaseSortBy = ['-release_date', '-id'];

  const getSiteNotification = api.getItems<SiteNotification, SiteNotificationData>(
      'site-notifications',
      SiteNotification,
      ['notificationInteractions'],
      undefined,
      [notificationFilter],
      notificationPagination,
      notificationSortBy
  );
  const getMaintenances = api.getItems<Maintenance, MaintenanceData>(
      'maintenances',
      Maintenance,
      ['notificationInteractions'],
      undefined,
      undefined,
      undefined,
      maintenanceSortBy);
  const getReleases = api.getItems<Release, ReleaseData>(
      'releases',
      Release,
      ['notificationInteractions'],
      undefined,
      undefined,
      releasePagination,
      releaseSortBy
  );

  Promise.allSettled([getSiteNotification, getMaintenances, getReleases])
      .then((result) => {
        if (result[0].status !== "fulfilled") {
          console.log("failed getting site notifications data", result);
          return;
        }
        if (result[1].status !== "fulfilled") {
          console.log("failed getting maintenances data", result);
          return;
        }
        if (result[2].status !== "fulfilled") {
          console.log("failed getting releases data", result);
          return;
        }

        navbarStore.siteNotificationsList = result[0].value;

        const current_timestamp = Date.now();
        navbarStore.openPopupNextPopupNotification();
        navbarStore.siteNotificationsList.forEach(sn => {
          if(sn.client_from.getTime() <= current_timestamp && sn.client_until.getTime() >= current_timestamp) {
            expandedItems.value[`${sn.id}_client_message`] = true;
          }
        })

        maintenances.value = result[1].value;
        releasesList.value = result[2].value;
      })
      .finally(() => {
        isLoading.value = false;
      })
}
loadFromServer();

const userInteraction = computed (() => (notificationInteractions: NotificationInteraction[]) => {
  return notificationInteractions.filter(el => el.user_id === authStore.user.id).length;
})

const truncateText = computed(() => (id: number, name: string, text: string, maxLength: number) => {
  const key = `${id}_${name}`;

  if (expandedItems.value[key] === undefined || expandedItems.value[key] === false) {
    if (text?.length > maxLength) {
      const html_doc = new DOMParser().parseFromString(text, 'text/html');
      return  html_doc.body.textContent.slice(0, maxLength) + '...'
    }
  }

  return text;
});

const goToReleases = (release_id: number) => {
  router.push({ name: 'news', hash: `#release_${release_id}` });
  navbarStore.closeNotificationsList();
}
const goToApiReleases = (release_id: number) => {
  router.push({ name: 'self-service-news', hash: `#release_${release_id}` });
  navbarStore.closeNotificationsList();
}

const notificationSeen = (notification_id:number, site_notification_type:string) => {
  let notification_type = site_notification_type;
  if (site_notification_type === 'release') {
    notification_type = 'api_release';
  }

  const payload = {
    notification_id: notification_id,
    notification_type: notification_type,
  }

  api.createItem('notification-interactions', payload, NotificationInteraction)
      .then((result) => {
        switch (site_notification_type) {
          case "site_notification":
            let notif = navbarStore.filteredSiteNotifications.find(el => el.id=== notification_id);
            notif.notificationInteractions.push(result);
            break;
          case "release":
            let release = releasesList.value.find(el => el.id=== notification_id);
            release.notificationInteractions.push(result);
            goToReleases(notification_id);
            break;
          case "api_release":
            let apiRelease = releasesList.value.find(el => el.id=== notification_id);
            apiRelease.notificationInteractions.push(result);
            goToApiReleases(notification_id);
            break;
          case "maintenance":
            let maintenance = maintenanceList.value.find(el => el.id=== notification_id);
            maintenance.notificationInteractions.push(result);
            break;
        }
      })
      .catch((err) => {
        console.log(err, 'error')
      })
      .finally(() => {
        if (site_notification_type === 'release') {
          goToReleases(notification_id);
        } else if (site_notification_type === 'api_release') {
          goToApiReleases(notification_id);
        }
      })
}

const toggleExpanded = computed(() => (id: number, name: string) => {
  const key = `${id}_${name}`;

  if (expandedItems.value[key] === undefined) {
    expandedItems.value[key] = true;
  } else {
    expandedItems.value[key] = !expandedItems.value[key];
  }

});

</script>

<style scoped>

</style>